// extracted by mini-css-extract-plugin
export default {"river":"river__river--1RItT"};
    if(module.hot) {
      // 1789733836851
      var cssReload = require("/bento3/bento_cms/static_src/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  